export default __webpack_public_path__ + "static/media/grafema_SET_16.e9d3388c.jpg";